import { render } from "./Navtab.vue?vue&type=template&id=267bbd8c&scoped=true"
const script = {}

import "./Navtab.vue?vue&type=style&index=0&id=267bbd8c&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267bbd8c"]])

export default __exports__